<template>
  <v-card flat>
    <v-slide-y-reverse-transition mode="out-in">
      <div
        class="font-weight-normal mb-1 mt-1 clas
      ml-4"
        v-if="items.length >= 0"
      >
        <template v-for="(i, index) in items">
          <v-hover :key="index">
            <span
              slot-scope="{ hover }"
              @click="i.to ? $router.push(i.to) : () => {}"
              :class="{
                'primary--text text-darken-2': hover && (i.force || index < items.length - 1),
                'primary--text text--lighten-2': !hover && index < items.length - 1,
                'grey--text text--darken-2': !hover && index === items.length - 1
              }"
              :style="hover && (index < items.length - 1 || i.force) ? 'cursor:pointer' : ''"
            >
              <v-icon v-if="i.icon" :size="20" :color="index < items.length - 1 ? 'primary' : 'grey'" class="mr-1 py-3 mb-1">{{ i.icon }}</v-icon>
              {{ i.title }}
            </span>
          </v-hover>
          <span class="grey--text" :key="`s_${index}`" v-if="index < items.length - 1"> <v-icon color="primary lighten-1" class="mb-1">mdi-chevron-right</v-icon></span>
        </template>
      </div>
    </v-slide-y-reverse-transition>
  </v-card>
</template>

<script>
// @group Global Component
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {}
};
</script>
